import WorkspaceTiles from '@/components/WorkspaceTiles';

export default function WorkspacesPage() {
  return (
    <div className="pagewrap home-v2" data-testid="workspaces-page">
      <div style={{ marginBottom: -18 }}>
        <h1 className="text-2xl font-bold" style={{ letterSpacing: '-0.02em' }}>Workspaces</h1>
        <p className="text-sm text-muted-foreground mt-1">Every workspace you own or belong to — drag tiles to reorder.</p>
      </div>
      <WorkspaceTiles />
    </div>
  );
}
